import { MILL_1 } from "@/setup/mill-config/mill-config";

/** Each mill has its own incentive procedures, e.g. "M1.GetIncentiveByWeek". */
export const incentiveRealtimeTopic = (
	assetId: number,
	procedure: "GetIncentiveByWeek" | "GetIncentiveReport",
) => `${assetId === MILL_1.id ? "M1" : "M2"}.${procedure}`;
